import Button from 'component/Buttons/login-button'
import InputFieldOutlined from 'component/Inputs/dashboard-input'
import InputFieldDate from 'component/Inputs/date-input'
import Accordion from 'component/accordion'
import Loader from 'component/loader'
import { TYPES } from 'enums/campaigns'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import Api from 'utils/api'
import * as yup from 'yup'

export const deviceDetails = (code) => {
  const { userAgent } = navigator
  let browserName

  if (userAgent.indexOf('Firefox') !== -1) {
    browserName = 'Mozilla Firefox'
  } else if (
    userAgent.indexOf('Opera') !== -1 ||
    userAgent.indexOf('OPR') !== -1
  ) {
    browserName = 'Opera'
  } else if (userAgent.indexOf('Trident') !== -1) {
    browserName = 'Microsoft Internet Explorer'
  } else if (userAgent.indexOf('Edge') !== -1) {
    browserName = 'Microsoft Edge'
  } else if (userAgent.indexOf('Chrome') !== -1) {
    browserName = 'Google Chrome'
  } else if (userAgent.indexOf('Safari') !== -1) {
    browserName = 'Apple Safari'
  } else {
    browserName = 'Unknown'
  }

  return {
    browser_name: browserName,
    device_os: window.navigator.platform,
    device_id: [
      code,
      navigator.userAgent,
      navigator.language,
      navigator.platform,
      window.screen.colorDepth,
      window.screen.width,
      window.screen.height,
    ]
      .map((item) => String(item))
      .join('-'),
  }
}

const Birthdate = yup.object({
  birth_date: yup.date().required(),
})

const AllowedMembers = yup.object({
  allowed_members: yup.number().integer().required(),
})

const AppointmentDate = yup.object({
  appointment_date: yup.date().required(),
})

const CreatePassSchema = yup.object({
  firstname: yup.string().required().label('First Name'),
  lastname: yup.string().required().label('Last Name'),
  email: yup.string().required().email().label('Email'),
  phone: yup.string().required().label('Phone'),
})

const initPassValues = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
}

function RegisterPassFormGrothtool() {
  const [loader, setLoader] = useState(true)
  const [growthtool, setGrowthtool] = useState()
  const [campaign, setCampaign] = useState()
  const { growthtool_code, campaign_code } = useParams()
  const [processing, setProcessing] = useState(false)
  const navigate = useNavigate()

  console.log('createeeee passssss')
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  // Access individual query parameters
  const referral = queryParams.get('referral')

  const getCampaignByCode = async () => {
    const { response } = await Api(
      '/campaign/public/campaign_code?campaign_code=' + campaign_code,
      'get'
    )

    if (response) {
      setCampaign(response.data)
      setLoader(false)
      const details = deviceDetails(campaign_code)
      await Api('/impressions', 'post', {
        payload: { ...details, campaign_id: response.data._id },
      })
    }
  }

  const getGrowthtoolByCode = async () => {
    const { response } = await Api(
      '/growth_tool/public/growthtoolCode?growthtool_code=' + growthtool_code,
      'get'
    )

    if (response) {
      setGrowthtool(response.data)
      getCampaignByCode()
      const details = deviceDetails(growthtool_code)
      await Api('/impressions', 'post', {
        payload: { ...details, growthtool_id: response.data._id },
      })
    }
  }

  const onLoad = () => {
    getGrowthtoolByCode()
  }

  useEffect(onLoad, [])

  console.log()

  const handleSubmit = async (form) => {
    setProcessing(true)
    const { response } = await Api(
      window.location.pathname.includes('citypass')
        ? '/pass/citypass'
        : '/pass',
      'post',
      {
        payload: {
          ...form,
          campaign_code,
          growthtool_code,
          referral,
        },
        notify: true,
      }
    )
    setProcessing(false)
    if (response) navigate('/customer/pass/' + response.data.pass_code)
  }

  const getSchema = () => {
    const schema = CreatePassSchema
    if (!campaign) return schema

    switch (campaign.type) {
      case TYPES.BIRTHDAY:
        return schema.concat(Birthdate)
      case TYPES.EVENT:
        return schema.concat(AllowedMembers)
      case TYPES.APPOINTMENT:
        return schema.concat(AppointmentDate)
      default:
        return schema
    }
  }

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div
          style={{ backgroundColor: growthtool?.settings?.page_bg_color }}
          className='h-screen overflow-y-auto'
        >
          <div className='mx-auto max-w-6xl'>
            <div className='mb-8 md:mb-16'>
              <img
                src={
                  growthtool?.settings?.cover || 'https://placehold.co/600x600'
                }
                alt='logo'
                className='object-cover w-full max-h-80'
              />
              <div
                className='w-fit mx-auto -mt-9 md:-mt-20 border-2 border-white rounded-full'
                style={{ width: '150px', height: '150px' }}
              >
                <img
                  src={
                    growthtool?.settings?.logo || 'https://placehold.co/600x600'
                  }
                  alt='cover'
                  className='object-fill w-full h-full rounded-full'
                />
              </div>
            </div>
            <div className='max-w-xl mx-auto px-4'>
              <div
                style={{
                  backgroundColor: growthtool?.settings?.header_bg_color,
                  color: growthtool?.settings?.header_text_color,
                }}
                className='w-[calc(100%-86px)] mx-auto -mb-6 relative py-3 md:py-4 rounded-lg text-white text-center bg-blue-500'
              >
                <div className='font-bold text-inherit text-lg'>
                  {growthtool?.settings?.title || 'Enrollment'}
                </div>
                <div className='text-sm font-light text-inherit'>
                  {growthtool?.settings?.subtitle}
                </div>
              </div>
              <div
                style={{
                  backgroundColor: growthtool?.settings.card_bg_color,
                  color: growthtool?.settings?.card_text_color,
                }}
                className='border bg-white py-6 px-12 rounded-lg shadow-md'
              >
                <Formik
                  initialValues={initPassValues}
                  validationSchema={getSchema()}
                  onSubmit={handleSubmit}
                  isInitialValid={false}
                >
                  {({ isValid, errors }) => (
                    <Form>
                      {console.log(errors)}
                      <div className='grid md:grid-cols-2 md:gap-x-3 mt-6 md:mt-8 mb-2 md:mb-3'>
                        <div className=''>
                          <InputFieldOutlined
                            label={'First Name'}
                            name='firstname'
                            labelClass={'text-inherit'}
                          />
                        </div>
                        <div className='mt-2 md:mt-0'>
                          <InputFieldOutlined
                            label={'Last Name'}
                            name='lastname'
                            labelClass={'text-inherit'}
                          />
                        </div>
                      </div>
                      <div className='my-2 md:my-3'>
                        <InputFieldOutlined
                          label={'Email'}
                          name='email'
                          labelClass={'text-inherit'}
                        />
                      </div>
                      <div className='my-2 md:my-3'>
                        <InputFieldOutlined
                          label={'Phone'}
                          name='phone'
                          labelClass={'text-inherit'}
                        />
                      </div>
                      {campaign?.type === TYPES?.APPOINTMENT && (
                        <div className='my-2 md:my-3'>
                          <InputFieldDate
                            label={'Appointment Date'}
                            name='appointment_date'
                            labelClass={'text-inherit'}
                          />
                        </div>
                      )}
                      {campaign?.type === TYPES?.EVENT && (
                        <div className='my-2 md:my-3'>
                          <InputFieldOutlined
                            type={'number'}
                            label={'Allowed Members'}
                            name='allowed_members'
                            labelClass={'text-inherit'}
                          />
                        </div>
                      )}
                      {campaign?.type === TYPES?.BIRTHDAY && (
                        <div className='my-2 md:my-3'>
                          <InputFieldDate
                            label={'Date Of Birth'}
                            name='birth_date'
                            labelClass={'text-inherit'}
                          />
                        </div>
                      )}
                      <div className='my-4 md:my-6'>
                        <Button
                          type={'submit'}
                          className={'w-full'}
                          label={'Subscribe Now'}
                          disabled={!isValid}
                          processing={processing}
                          style={{
                            backgroundColor:
                              growthtool?.settings?.card_button_bg_color,
                            color: growthtool?.settings?.card_button_text_color,
                          }}
                        />
                      </div>
                      {growthtool?.settings?.show_terms && (
                        <div className='mx-3 mt-4'>
                          <Accordion
                            items={[
                              {
                                title: (
                                  <div className='text-sm font-semibold'>
                                    Terms of use
                                  </div>
                                ),
                                body: (
                                  <div
                                    className='text-xs font-light ck-content'
                                    dangerouslySetInnerHTML={{
                                      __html: growthtool?.settings?.terms,
                                    }}
                                  ></div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default RegisterPassFormGrothtool
